'use strict';

if (String.prototype.trim == null) {
  // Make sure we trim BOM and NBSP
  const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

  String.prototype.trim = function () {
    return this.replace(rtrim, '');
  };
}
